import React from "react";
import FeatureCard from "./FeatureCard";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { faThermometerHalf } from "@fortawesome/free-solid-svg-icons";
import { faCloudUpload } from "@fortawesome/free-solid-svg-icons";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "../Cards.css";

function FeatureCardCMLife() {
  return (
    <div className="cards">
      <div className="cards__container">
        <div className="feature-cards__wrapper">
          <ul className="feature-card__item">
            <FeatureCard
              iconName={faCalculator}
              header="Centralization Calculation"
              text="Calculation of centralization at centralizer installation points and between them, taking into account pipe deflection. Maximum calculation accuracy based on centralizer test data according to API 10D."
              // header="Расчет центрации"
              // text="Расчет центрации в месте установки центраторов и между ними с учетом прогиба трубы. Максимальная точность расчетов на основе данных с тестов центраторов согласно API 10D."
            />
            <FeatureCard
              iconName={faThermometerHalf}
              header="Thermodynamic Temperature Calculation"
              text="Modern thermodynamic temperature calculation algorithm allows for more accurate selection of technical specifications for the laboratory."
              // header="Термодинамический расчет температуры"
              // text="Современный алгоритм термодинамического расчета температуры позволяет более точно подобрать техническое задание для лаборатории."
            />
            <FeatureCard
              iconName={faCogs}
              header="Torque and Drag"
              text="Helps determine risks of casing string not reaching target depth and calculate the possibility of rotating casing string during cementing, considering actual casing string parameters."
              // header="Крутящий момент и сопротивление"
              // text="Помогает определить риски недохождения ОК до проектного забоя и рассчитать возможность вращения ОК при цементировании с учетом реальных параметров ОК."
            />
            <FeatureCard
              iconName={faScrewdriverWrench}
              header="Bridge Plug Setting"
              text="The software suite supports balanced cement bridge plug setting calculations."
              // header="Установка мостов"
              // text="Программный комплекс поддерживает расчет установки цементных мостов на баланс."
            />
          </ul>
          <ul className="feature-card__item">
            <FeatureCard
              iconName={faCloudUpload}
              header="Caliper Log Import"
              text="The ability to import caliper logs enables more accurate 3D displacement calculations."
              // header="Импорт кавернометрии"
              // text="Возможность импорта кавернометрии позволяет добиться более точных расчетов по 3д вытеснению."
            />
            <FeatureCard
              iconName={faSearch}
              header="Case Comparison"
              text="Ability to compare multiple calculation results with different parameters."
              // header="Сравнение кейсов"
              // text="Возможность сравнить несколько результатов расчетов при разных параметров."
            />
            <FeatureCard
              iconName={faMobileScreenButton}
              header="User-Friendly Interface"
              text="Intuitive interface that makes working with the application as comfortable and efficient as possible."
              // header="Понятный интерфейc"
              // text="Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным."
            />
            <FeatureCard
              iconName={faHeadset}
              header="Technical Support"
              text="Continuously updated technical support, ensuring uninterrupted operation of your laboratory."
              // header="Техническая поддержка"
              // text="Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу вашей лаборатории."
            />
          </ul>

          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faCalculator}
              header="Centralization Calculation"
              text="Calculation of centralization at centralizer installation points and between them, taking into account pipe deflection. Maximum calculation accuracy based on centralizer test data according to API 10D."
              // header="Расчет центрации"
              // text="Расчет центрации в месте установки центраторов и между ними с учетом прогиба трубы. Максимальная точность расчетов на основе данных с тестов центраторов согласно API 10D."
            />
            <FeatureCard
              iconName={faThermometerHalf}
              header="Thermodynamic Temperature Calculation"
              text="Modern thermodynamic temperature calculation algorithm allows for more accurate selection of technical specifications for the laboratory."
              // header="Термодинамический расчет температуры"
              // text="Современный алгоритм термодинамического расчета температуры позволяет более точно подобрать техническое задание для лаборатории."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faCogs}
              header="Torque and Drag"
              text="Helps determine risks of casing string not reaching target depth and calculate the possibility of rotating casing string during cementing, considering actual casing string parameters."
              // header="Крутящий момент и сопротивление"
              // text="Помогает определить риски недохождения ОК до проектного забоя и рассчитать возможность вращения ОК при цементировании с учетом реальных параметров ОК."
            />
            <FeatureCard
              iconName={faScrewdriverWrench}
              header="Bridge Plug Setting"
              text="The software suite supports balanced cement bridge plug setting calculations."
              // header="Установка мостов"
              // text="Программный комплекс поддерживает расчет установки цементных мостов на баланс."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faCloudUpload}
              header="Caliper Log Import"
              text="The ability to import caliper logs enables more accurate 3D displacement calculations."
              // header="Импорт кавернометрии"
              // text="Возможность импорта кавернометрии позволяет добиться более точных расчетов по 3д вытеснению."
            />
            <FeatureCard
              iconName={faSearch}
              header="Case Comparison"
              text="Ability to compare multiple calculation results with different parameters."
              // header="Сравнение кейсов"
              // text="Возможность сравнить несколько результатов расчетов при разных параметров."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faMobileScreenButton}
              header="User-Friendly Interface"
              text="Intuitive interface that makes working with the application as comfortable and efficient as possible."
              // header="Понятный интерфейc"
              // text="Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным."
            />
            <FeatureCard
              iconName={faHeadset}
              header="Technical Support"
              text="Continuously updated technical support, ensuring uninterrupted operation of your laboratory."
              // header="Техническая поддержка"
              // text="Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу вашей лаборатории."
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FeatureCardCMLife;
